import CryptoJS from 'crypto-js';
import http from '@/assets/js/http'
import FileServiceSignatureUrl from '@/assets/js/constant/file-service-signature-url.js'
import { baseStore, baseAcs } from '@/assets/js/base-url.js'
import store from "@/store";
import { Message } from 'element-ui';
// import baseSSO from "../assets/js/base-sso";
// import baseSSOFED from "../assets/js/base-ssofed";

let abc = '[Golden PIPE ] -> GP';

// let secret = window.BaseConfigInfo.baseSSO.secret;
let secret = CryptoJS.AES.decrypt(window.BaseConfigInfo.baseSSO.dimension1.toString(), CryptoJS.enc.Utf8.parse(abc), {
  mode: CryptoJS.mode.ECB,
  padding: CryptoJS.pad.Pkcs7
}).toString(CryptoJS.enc.Utf8);

/**
 * 工具类
 */
export default {
  createString(length) {
    var expect = length;
    var str = Math.random().toString(36).substr(2);
    while (str.length < expect) {
      str += Math.random().toString(36).substr(2);
    }
    str = str.substr(0, length);
    return str;
  },
  decrypt(msg){ //AES解密
     let result = CryptoJS.AES.decrypt(msg, CryptoJS.enc.Utf8.parse(abc), {
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7
    }).toString(CryptoJS.enc.Utf8);
    //  console.info(result);
     return result;
  },

  encrypt(msg, keyStr,ivKey) { //AES加密
    let key = keyStr // 16位加密密钥，16位则位128bit
    let iv = ivKey // 16位偏移量，可与密钥相同
    key = CryptoJS.enc.Utf8.parse(key)
    iv = CryptoJS.enc.Utf8.parse(iv)
    const srcs = CryptoJS.enc.Utf8.parse(msg)
    const encrypted = CryptoJS.AES.encrypt(srcs, key, {
      iv: iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.ZeroPadding
    })
    return encrypted.toString()
  },
  /**
   * 自定义生成uuid方法
   */
  generateUUID() {
    var d = new Date().getTime();
    var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      var r = (d + Math.random() * 16) % 16 | 0;
      d = Math.floor(d / 16);
      return (c == 'x' ? r : (r & 0x3 | 0x8)).toString(16);
    });
    return uuid;
  },

  /**
   * sign签名生成规则(GET/POST FORM)
   *
   */
  generateGetSign(params, url) {
    let paramStr = secret + this.generateParamStr(params, url) + secret;
    if (url.indexOf(baseSSO.refresh_token_url) === -1
      && url.indexOf(baseSSOFED.refresh_token_url) === -1
      && url.indexOf(baseSSOShared.refresh_token_url) === -1
      && url.indexOf('/dsis/fs/signature-upload-file') === -1
      && url.indexOf('/ns/notifications/msg-summary') === -1
      && url.indexOf('/dacs/ida-task/query/step-group-task-status') === -1
      && url.indexOf("/acs/function-api-mapping/get-function-permission-by-user") === -1
      && url.indexOf("/v1/refreshToken") === -1
    ) {
      window.localStorage.setItem("recent_user_time", new Date().getTime());
    }
    // console.info(paramStr)
    let sign = CryptoJS.SHA256(paramStr).toString().toUpperCase();
    return sign;
  },
  /**
   * sign签名生成规则(POST Json)
   *
   */
  generatePostJsonSign(params, url, postJson) {
    //增加body参数,用于生成sign
    if (postJson) {
      let bodyString = "";
      // bodyString = this.generateObject(postJson);
      bodyString = JSON.stringify(postJson);
      params.body = bodyString;
    }

    let paramStr = secret + this.generateParamStr(params, url) + secret;
    //删除body参数,以免影响query paramter
    delete params.body;
    //不向浏览器暴露sign，正式发布时需要注释
    // console.info(md5Str);
    // let sign = md5(md5Str);

    if (url.indexOf(baseSSO.refresh_token_url) === -1
      && url.indexOf(baseSSOFED.refresh_token_url) === -1
      && url.indexOf(baseSSOShared.refresh_token_url) === -1
      && url.indexOf('/dsis/fs/signature-upload-file') === -1
      && url.indexOf('/ns/notifications/msg-summary') === -1
      && url.indexOf('/dacs/ida-task/query/step-group-task-status') === -1
      && url.indexOf("/acs/function-api-mapping/get-function-permission-by-user") === -1
      && url.indexOf("/v1/refreshToken") === -1
    ) {
      window.localStorage.setItem("recent_user_time", new Date().getTime());
    }
    // console.info(paramStr)
    let sign = CryptoJS.SHA256(paramStr).toString().toUpperCase();
    return sign;
  },

  /**
   * split url 截取url
   * return 不含参数的url
   */
  splitUrl(params, url) {
    if (url.indexOf("?") !== -1) {
      let urlParams = url.split("?")[1].split("&");
      if (urlParams.length > 0) {
        for (var i = 0; i < urlParams.length; i++) {
          //排除参数值为空的字段
          if (this.isNotNullNorEmpty(urlParams[i])) {
            let paramsUnitArr = urlParams[i].split("=");
            //不包含=直接丢掉
            if (paramsUnitArr.length == 2) {
              params[paramsUnitArr[0]] = paramsUnitArr[1];
            }
          }
        }
      }
      return url.split("?")[0];
    } else {
      return url;
    }
  },
  /**
   * encode split  url 会对url参数进行encode
   * return encode的url,包含参数
   */
  encodeSplitUrl(url) {
    if (url.indexOf("?") !== -1) {
      let urlPrefix = url.split("?")[0];
      let urlParams = url.split("?")[1].split("&");

      if (urlParams.length > 0) {
        urlPrefix += "?";
        for (var i = 0; i < urlParams.length; i++) {
          //排除参数值为空的字段
          if (this.isNotNullNorEmpty(urlParams[i])) {
            let paramsUnitArr = urlParams[i].split("=");
            //不包含=直接丢掉
            if (paramsUnitArr.length === 2 && this.isNotNullNorEmpty(paramsUnitArr[1])) {
              if (i === 0) {
                urlPrefix += encodeURIComponent(paramsUnitArr[0]) + "=" + encodeURIComponent(paramsUnitArr[1]);
              } else {
                urlPrefix += "&" + encodeURIComponent(paramsUnitArr[0]) + "=" + encodeURIComponent(paramsUnitArr[1]);

              }
            }
          }
        }
      }
      return urlPrefix;
    } else {
      return url;
    }
  },
  /**
   * encode split  url 会对url参数进行encode
   * return encode的url,包含参数
   */
  encodeSplitParams(url, params) {
    if (!params) {
      return url;
    }
    let unitArray = [];
    url += url.indexOf("?") === -1 ? '?' : '&';
    let urlParams = url.split("?")[1].split("&");

    let paramArr = Object.keys(params);
    for (let i = 0; i < paramArr.length; i++) {
      let value = params[paramArr[i]];

      //排除参数值为空的字段
      if (this.isNotNullNorEmpty(value)) {
        if (typeof value === 'object') {
          for (let j = 0; j < value.length; j++) {
            unitArray.push(paramArr[i] + "=" + decodeURI(value[j]));
          }
        } else {
          unitArray.push(paramArr[i] + "=" + decodeURI(value));
        }
      }
    }

    unitArray.sort();
    return url + unitArray.join("&");
    ;

  },
  /**
   *
   * @param url 拆分url，丢弃空参数空value
   * @returns {*}
   */
  splitUrlDiscardedEmptyValue(url) {
    if (url.indexOf("?") !== -1) {
      let urlPrefix = url.split("?")[0];
      let urlParams = url.split("?")[1].split("&");

      if (urlParams.length > 0) {
        urlPrefix += "?";
        for (var i = 0; i < urlParams.length; i++) {
          //排除参数值为空的字段
          if (this.isNotNullNorEmpty(urlParams[i])) {
            let paramsUnitArr = urlParams[i].split("=");
            //不包含=直接丢掉
            if (paramsUnitArr.length === 2 && this.isNotNullNorEmpty(paramsUnitArr[1])) {
              if (i === 0) {
                urlPrefix += paramsUnitArr[0] + "=" + paramsUnitArr[1];
              } else {
                urlPrefix += "&" + paramsUnitArr[0] + "=" + paramsUnitArr[1];

              }
            }
          }
        }
      }
      return urlPrefix;
    } else {
      return url;
    }
  },
  /**
   * 为sign签名准备的url字符串
   */
  generateParamStr(params, url) {
    let unitArray = [];
    let distinctParam = {};
    if (url.indexOf("?") !== -1) {
      let urlParams = url.split("?")[1].split("&");
      if (urlParams.length > 0) {
        for (var i = 0; i < urlParams.length; i++) {
          //排除参数值为空的字段
          if (this.isNotNullNorEmpty(urlParams[i])) {
            let paramsUnitArr = urlParams[i].split("=");
            // console.info(paramsUnitArr)
            //不包含=直接丢掉
            if (paramsUnitArr.length === 2 && this.isNotNullNorEmpty(paramsUnitArr[1])) {
              unitArray.push(paramsUnitArr[0] + "=" + paramsUnitArr[1]);
            }
          }
        }
      }
    }
    let paramArr = Object.keys(params);
    for (let i = 0; i < paramArr.length; i++) {
      let value = params[paramArr[i]];

      if (this.isNotNullNorEmpty(value)) {
        if (typeof value === 'object') {
          for (let j = 0; j < value.length; j++) {
            unitArray.push(paramArr[i] + "=" + decodeURI(value[j]));
          }
        }else{
          if(paramArr[i] === 'body'){
            unitArray.push(paramArr[i] + "=" + value);
          }else{
            unitArray.push(paramArr[i] + "=" + decodeURI(value));
          }
        }
      } else {
        //空值不能丢掉
        unitArray.push(paramArr[i] + "=");
      }
    }

    unitArray.sort();
    let md5Str = unitArray.join("&");
    return md5Str;
  },
  generateObject(postJson) {
    let str = "";
    let postJsonKeys = Object.keys(postJson);
    postJsonKeys.sort();
    for (var i = 0; i < postJsonKeys.length; i++) {
      let obj = postJson[postJsonKeys[i]];
      if (obj instanceof Array) {
        str += "&";
        str += postJsonKeys[i];
        str += "=[";
        str += this.generateArray(obj);
        str += "]"
      } else if (typeof obj === 'string' || typeof obj === 'number' || typeof obj === 'boolean' || obj == null) {

        str += "&";
        str += postJsonKeys[i];
        str += "=";
        str += obj;
      } else {
        str += "&";
        str += postJsonKeys[i];
        str += "=";
        str += "{";
        str += this.generateObject(obj);
        str += "}";
      }

    }
    if (str.length > 0) {
      return str.substring(1);
    }

    return str;
  },
  generateArray(postJson) {
    let unitArr = [];
    for (var i = 0; i < postJson.length; i++) {
      let temp = "";
      let obj = postJson[i];
      if (typeof obj === 'string' || typeof obj === 'number' || typeof obj === 'boolean' || obj == null) {
        temp = obj;
      } else {
        temp = this.generateObject(obj);
      }
      unitArr.push(temp);
    }

    let str = "";
    if (unitArr != null && unitArr.length > 0) {
      unitArr.sort();
      for (var i = 0; i < unitArr.length; i++) {
        str += "{";
        str += unitArr[i];
        str += "}";
        str += ",";
      }
      return str.substring(0, (str.length - 1));
    }
    return str;
  },
  isNullOrEmpty(str) {
    return str == null || str === "";
  },
  isNotNullNorEmpty(str) {
    return str != null && str !== "";
  },
  getAuthorizationHeader(token) {
    let headerParam = {};
    let pgUser = JSON.parse(window.localStorage.getItem('userInfo'));
    //取消用户传过来的token,自己获取token
    headerParam.Authorization = 'Bearer ' + token;
    headerParam["REQUEST-ID"] = this.generateUUID();
    headerParam["X-USERNAME"] = pgUser.username;
    return headerParam;
  },
  appendSSOParam(url) {
    url += (url.indexOf("?") !== -1) ? "&" : "?";
    // url += "apiKey=inventory-xkZzPkbrL1vDjHM1";
    url += "api_key=" + window.localStorage.getItem('apiKey');
    url += '&t=' + new Date().getTime();

    let params = {};
    // params.token = 'PgTT0stft9qA7JGJp7f0oWT7j7pJ046j';
    url += '&sign=' + this.generateGetSign(params, url);
    url = this.encodeSplitUrl(url);
    return url;
  },
  endWith(str, suffix) {
    if (suffix == null || suffix == "" || str.length == 0 || suffix.length > str.length) {
      return false;
    }
    if (str.substring(str.length - suffix.length)) {
      return true;
    } else {
      return false;
    }
    return true;
  },
  startWith(str, prefix) {
    if (prefix == null || prefix == "" || str.length == 0 || prefix.length > str.length) {
      return false;
    }
    if (str.substring(0, prefix.length) == prefix) {
      return true;
    } else {
      return false;
    }
    return true;
  },
  // 对象的深度克隆（Array / obj /...）
  deepClone(obj) {
    var str, retObj = Object.prototype.toString.call(obj) === '[object Array]' ? [] : {};
    if (typeof obj !== 'object') {
      return;
    } else if (window.JSON) {
      str = JSON.stringify(obj);
      retObj = JSON.parse(str);
    }
    else {
      for (var prop in obj) {
        retObj[prop] = typeof obj[prop] === 'object' ? deepClone(obj[prop]) : obj[prop];
      }
    }
    return retObj;
  },
  jointSpecialUrl(url, params) {
    url += (url.indexOf("?") !== -1) ? "&" : "?";
    // url += "apiKey=inventory-xkZzPkbrL1vDjHM1";
    url += "api_key=" + window.localStorage.getItem('apiKey');
    url += '&timestamp=' + new Date().toISOString().replace('T', ' ').slice(0, -5);
    url += '&nonce_str=' + this.generateUUID();

    params = params == null ? {} : params;
    // params.token = 'PgTT0stft9qA7JGJp7f0oWT7j7pJ046j'
    url += '&sign=' + this.generateGetSign(params, url);
    if (url.indexOf(baseSSO.refresh_token_url) === -1
      && url.indexOf(baseSSOFED.refresh_token_url) === -1
      && url.indexOf(baseSSOShared.refresh_token_url) === -1
      && url.indexOf('/dsis/fs/signature-upload-file') === -1
      && url.indexOf('/ns/notifications/msg-summary') === -1
      && url.indexOf('/dacs/ida-task/query/step-group-task-status') === -1
      && url.indexOf("/acs/function-api-mapping/get-function-permission-by-user") === -1
      && url.indexOf("/v1/refreshToken") === -1
    ) {
      window.localStorage.setItem("recent_user_time", new Date().getTime());
    }
    url = this.splitUrlDiscardedEmptyValue(url);
    return url;
  },
  getFileSignature(dataLoading, fileId) {
    let data = this.getExportSignatureUrl(fileId);
    dataLoading = false;
    if (data) {
      return data;
    } else {
      Message.warning('Export failed.');
    }
  },
  /**
   * 通用下载方法：通过动态创建 <a> 标签触发浏览器下载
   * - 不打开新标签页，避免 window.open 的闪烁问题
   * - a 标签隐藏 display:none，避免影响页面布局
   * - 点击后立即从 DOM 中移除并释放引用，避免内存泄漏
   * - 兼容 URL 中已带签名参数的直链
   * @param {string} url 下载地址（必填）
   * @param {string} [filename] 可选，下载保存的文件名；为空时由浏览器读取响应头 Content-Disposition
   * @returns {boolean} 是否成功触发下载（url 为空时返回 false）
   */
  triggerDownload(url, filename = '') {
    if (!url) return false;
    const link = document.createElement('a');
    link.href = url;
    if (filename) {
      link.download = filename;
    }
    // 隐藏元素，避免影响页面布局或被用户误点
    link.style.display = 'none';
    document.body.appendChild(link);
    link.click();
    // 移除 DOM 节点并释放引用，防止内存泄漏
    document.body.removeChild(link);
    link.href = '';
    return true;
  },
  // getFileSignatureForUploadUrl(dataLoading){
  //   http.get(window.BaseConfigInfo.baseSSO.download_file_url).then(resp => {
  //     return "signature=" + resp.data.signature
  //       + "&subscriptionKey=" + resp.data.subscriptionKey
  //       + "&timestamp=" + new Date().getTime()
  //       + "&public=true";
  //   }).catch(error => {
  //       //dataLoading = false;
  //     }
  //   )
  // },
  cmrDownFileById(fileId) {
    let data = this.getExportSignatureUrlCMR(fileId);
    if (data) {
      return data;
    } else {
      Message.warning('Export failed.');
    }
  },

  getFileServiceSigntureAndSubscriptionKey(url, timestamp) {
    url += "&timestamp=" + timestamp;
    if (url) {
      http.get(url).then(resp => {
        return resp.data;
      }).catch(error => {
          //dataLoading = false;
        }
      )
    } else {
      return null;
    }

  },
  uploadFileUrl(url) {
    let timestamp = new Date().toISOString().replace('T', ' ').slice(0, -5);
    let data = this.getFileServiceSigntureAndSubscriptionKey(url, timestamp);
    if (data) {
      return "signature=" + resp.data.signature
        + "&subscriptionKey=" + resp.data.subscriptionKey
        + "&timestamp=" + timestamp
        + "&public=false";
    }
  },
  setRequestHeader(xhr) {
    let headerParam = {};
    let userInfo = JSON.parse(window.localStorage.getItem('userInfo'));
    xhr.setRequestHeader("REQUEST-ID", this.generateUUID());
    xhr.setRequestHeader("X-USERNAME", userInfo.username);

    xhr.setRequestHeader("Ocp-Apim-Subscription-Key", this.decrypt(window.localStorage.getItem('subscriptionKey')));
    xhr.setRequestHeader("Auth-Type", window.localStorage.getItem('authType'));
    // if(window.baseSSO.environment !== 'local') {
      xhr.setRequestHeader("Authorization", ('Bearer ' + userInfo.access_token));
    // }
    xhr.setRequestHeader("X-ROLENAME", window.localStorage.getItem('currentRole'));
    xhr.setRequestHeader("appKey", window.BaseConfigInfo.baseSSO.appKey);

    return xhr;
  },
  getUploadSignatureUrl() {
    let url = baseAcs + FileServiceSignatureUrl.UPLOAD_FILE;
    // let url = "http://192.168.199.161:8080/demo/fs/signature-upload-file?timestamp=1547264135218&is_public=false";
    let now = new Date();
    let timestamp = now.toISOString().replace('T', ' ').slice(0, -5);
    url += (url.indexOf("?") !== -1) ? "&" : "?";
    // url += "apiKey=inventory-xkZzPkbrL1vDjHM1";
    url += "api_key=" + window.localStorage.getItem('apiKey');
    url += '&nonce_str=' + this.generateUUID();
    url += "&timestamp=" + timestamp;
    url += "&timestamp_fs=" + now.getTime();
    url += "&is_public=false";

    let params = {};
    url += '&sign=' + this.generateGetSign(params, url);
    let uploadUrls = '';
    var xhr = new XMLHttpRequest();
    xhr.open('GET', url, false);
    this.setRequestHeader(xhr);
    xhr.onreadystatechange = function () {
      // readyState == 4说明请求已完成
      if (xhr.readyState == 4 && xhr.status == 200 || xhr.status == 304) {
        // 从服务器获得数据
        // fn.call(this, xhr.responseText);
        let responseData = JSON.parse(xhr.responseText);
        uploadUrls = window.BaseConfigInfo.baseSSO.upload_file_url + "?signature=" + responseData.signature
          + "&subscriptionKey=" + responseData.subscriptionKey
          + "&timestamp=" + timestamp
          + "&public=false";
      }
    };
    xhr.send();

    return uploadUrls;
  },
  getExportSignatureUrl(fileId) {
    let url = baseAcs + FileServiceSignatureUrl.DOWNLOAD_PRIVATE_FILE;
    // let url = "http://192.168.199.161:8080/demo/fs/signature-upload-file?timestamp=1547264135218&is_public=false";
    let now = new Date();
    let timestamp = now.toISOString().replace('T', ' ').slice(0, -5);

    url += (url.indexOf("?") !== -1) ? "&" : "?";
    // url += "apiKey=inventory-xkZzPkbrL1vDjHM1";
    url += "api_key=" + window.localStorage.getItem('apiKey');
    url += '&nonce_str=' + this.generateUUID();
    url += "&timestamp=" + timestamp;
    url += "&timestamp_fs=" + now.getTime();
    url += "&is_public=false";
    url += "&fileId=" + fileId;
    let params = {};
    url += '&sign=' + this.generateGetSign(params, url);
    let uploadUrls = '';
    var xhr = new XMLHttpRequest();
    xhr.open('GET', url, false);
    this.setRequestHeader(xhr);
    xhr.onreadystatechange = function () {
      // readyState == 4说明请求已完成
      if (xhr.readyState == 4 && xhr.status == 200 || xhr.status == 304) {
        // 从服务器获得数据
        // fn.call(this, xhr.responseText);
        let responseData = JSON.parse(xhr.responseText);
        uploadUrls = window.BaseConfigInfo.baseSSO.download_file_url + fileId + "?signature=" + responseData.signature
          + "&subscriptionKey=" + responseData.subscriptionKey
          + "&timestamp=" + now.getTime()
          + "&public=false";
      }
    };
    xhr.send();

    return uploadUrls;
  },
  getExportSignatureUrlCMR(fileId) {
    let url = window.BaseConfigInfo.baseSSO.domainNameCmr + FileServiceSignatureUrl.DOWNLOAD_PRIVATE_FILE_CMR;
    let now = new Date();
    let timestamp = now.toISOString().replace('T', ' ').slice(0, -5);

    url += (url.indexOf("?") !== -1) ? "&" : "?";
    url += "api_key=" + window.localStorage.getItem('apiKey');
    url += '&nonce_str=' + this.generateUUID();
    url += "&timestamp=" + timestamp;
    url += "&timestamp_fs=" + now.getTime();
    url += "&is_public=false";
    url += "&fileId=" + fileId;
    let params = {};
    url += '&sign=' + this.generateGetSign(params, url);
    let uploadUrls = '';
    var xhr = new XMLHttpRequest();
    xhr.open('GET', url, false);
    this.setRequestHeader(xhr);
    xhr.onreadystatechange = function () {
      // readyState == 4说明请求已完成
      if (xhr.readyState == 4 && xhr.status == 200 || xhr.status == 304) {
        // 从服务器获得数据
        let responseData = JSON.parse(xhr.responseText);
        uploadUrls = window.BaseConfigInfo.baseSSO.download_file_url + fileId + "?signature=" + responseData.data.signature
          + "&subscriptionKey=" + responseData.data.subscriptionKey
          + "&timestamp=" + now.getTime()
          + "&public=false";
      }
    };
    xhr.send();

    return uploadUrls;
  },
  // ispublic 是否共有
  getUploadSignatureFormData(formData, ispublic = false) {
    let url = baseAcs + FileServiceSignatureUrl.UPLOAD_FILE;
    // let url = "http://192.168.199.161:8080/demo/fs/signature-upload-file?timestamp=1547264135218&is_public=false";
    let now = new Date();
    let timestamp = now.toISOString().replace('T', ' ').slice(0, -5);
    url += (url.indexOf("?") !== -1) ? "&" : "?";
    // url += "apiKey=inventory-xkZzPkbrL1vDjHM1";
    url += "api_key=" + window.localStorage.getItem('apiKey');
    url += '&nonce_str=' + this.generateUUID();
    url += "&timestamp=" + timestamp;
    url += "&timestamp_fs=" + now.getTime();
    url += `&is_public=${ispublic}`;

    let params = {};
    url += '&sign=' + this.generateGetSign(params, url);
    let data = formData == null ? {} : formData;
    var xhr = new XMLHttpRequest();
    xhr.open('GET', url, false);
    this.setRequestHeader(xhr);
    xhr.onreadystatechange = function () {
      // readyState == 4说明请求已完成
      if (xhr.readyState == 4 && xhr.status == 200 || xhr.status == 304) {
        // 从服务器获得数据
        // fn.call(this, xhr.responseText);
        let responseData = JSON.parse(xhr.responseText);
        // uploadUrls = window.BaseConfigInfo.baseSSO.upload_file_url +  "?signature=" + responseData.signature
        //   + "&subscriptionKey=" + responseData.subscriptionKey
        //   + "&timestamp=" + timestamp
        //   + "&public=false";
        data["subscriptionKey"] = responseData.subscriptionKey;
        data["signature"] = responseData.signature;
        data["timestamp"] = now.getTime();
        data["public"] = ispublic;

      }
    };
    xhr.send();

    return data;
  },
  // ispublic 是否共有
  getUploadSignatureFormDataCmr(formData, ispublic = false) {
    let baseCmrUrl = window.BaseConfigInfo.baseSSO.domainNameCmr
    let url = baseCmrUrl + FileServiceSignatureUrl.UPLOAD_FILE_CMR;
    // let url = "http://192.168.199.161:8080/demo/fs/signature-upload-file?timestamp=1547264135218&is_public=false";
    let now = new Date();
    let timestamp = now.toISOString().replace('T', ' ').slice(0, -5);
    url += (url.indexOf("?") !== -1) ? "&" : "?";
    // url += "apiKey=inventory-xkZzPkbrL1vDjHM1";
    url += "api_key=" + window.localStorage.getItem('apiKey');
    url += '&nonce_str=' + this.generateUUID();
    url += "&timestamp=" + timestamp;
    url += `&isPublic=${ispublic}`;

    let params = {};
    url += '&sign=' + this.generateGetSign(params, url);
    let data = formData == null ? {} : formData;
    var xhr = new XMLHttpRequest();
    xhr.open('GET', url, false);
    let headerParam = {};
    let userInfo = JSON.parse(window.localStorage.getItem('userInfo'));
    xhr.setRequestHeader("REQUEST-ID", this.generateUUID());
    xhr.setRequestHeader("X-USERNAME", userInfo.username);

    xhr.setRequestHeader("Ocp-Apim-Subscription-Key", this.decrypt(window.localStorage.getItem('subscriptionKey')));
    xhr.setRequestHeader("Auth-Type", window.localStorage.getItem('authType'));
    xhr.setRequestHeader("Authorization", ('Bearer ' + userInfo.access_token));
    xhr.setRequestHeader("X-ROLENAME", window.localStorage.getItem('currentRole'));
    xhr.setRequestHeader("appKey", window.BaseConfigInfo.baseSSO.appKey);
    // this.setRequestHeader(xhr);
    xhr.onreadystatechange = function () {
      // readyState == 4说明请求已完成
      if (xhr.readyState == 4 && xhr.status == 200 || xhr.status == 304) {
        // 从服务器获得数据
        // fn.call(this, xhr.responseText);
        let responseData = JSON.parse(xhr.responseText);
        // uploadUrls = window.BaseConfigInfo.baseSSO.upload_file_url +  "?signature=" + responseData.signature
        //   + "&subscriptionKey=" + responseData.subscriptionKey
        //   + "&timestamp=" + timestamp
        //   + "&public=false";
        data["subscriptionKey"] = responseData.data.subscriptionKey;
        data["signature"] = responseData.data.signature;
        data["timestamp"] = responseData.data.timestamp
        data["public"] = ispublic;

      }
    };
    xhr.send();

    return data;
  },
  downloadPublicOrPrivateFileByUrlOrFileId(url) {
    if (url) {
      if (this.startWith(url, "https://")) {
        return url;
      } else {
        return this.getFileSignature(false, url);
      }
    }
    return null;
  },
  uploadFileForElementUpload(request, that,ispublic=false) {
    try {
      let data = this.getUploadSignatureFormData(null,ispublic);
      let formData = new FormData();
      formData.append("file", request.file);
      formData.append("subscriptionKey", data.subscriptionKey);
      formData.append("signature", data.signature);
      formData.append("timestamp", data.timestamp);
      formData.append("public", data.public);
  
      let xhr = new XMLHttpRequest();
      xhr.open('post', request.action, false);
      xhr.onload = (res) => that.handleSuccess(res, request.file.name); //请求完成
      xhr.onerror = that.handleError; //请求失败
      xhr.send(formData); //开始上传，发送form数据
    } catch (error) {
      that.handleError();
      // 加个异常处理，由些时候，莫名报 timeOut
      if (that.timeOutErr) {
        that.timeOutErr();
      }
    }
  },
  uploadFileForElementUploadCmr(request, that,ispublic=false) {
    try {
      let data = this.getUploadSignatureFormDataCmr(null,ispublic);
      let formData = new FormData();
      formData.append("file", request.file);
      formData.append("subscriptionKey", data.subscriptionKey);
      formData.append("signature", data.signature);
      formData.append("timestamp", data.timestamp);
      formData.append("public", data.public);
  
      let xhr = new XMLHttpRequest();
      xhr.open('post', request.action, false);
      xhr.onload = (res) => that.handleSuccess(res, request.file, request.file.name); //请求完成
      // xhr.onerror = that.handleError(request); //请求失败
      xhr.send(formData); //开始上传，发送form数据
    } catch (error) {
      that.handleError(request);
      // 加个异常处理，由些时候，莫名报 timeOut
      if (that.timeOutErr) {
        that.timeOutErr();
      }
    }
  },

  // 把url中的参数转化为json对象
  parseQueryString: function (url) {
    var reg_url = /^[^\?]+\?([\w\W]+)$/,
      reg_para = /([^&=]+)=([\w\W]*?)(&|$|#)/g,
      arr_url = reg_url.exec(url),
      ret = {};
    if (arr_url && arr_url[1]) {
      var str_para = arr_url[1], result;
      while ((result = reg_para.exec(str_para)) != null) {
        ret[result[1]] = result[2];
      }
    }
    return ret;
  },


  // 匹配字母，数字，下划线
  matchWordCase(str) {
    return this.match("^[0-9a-zA-Z_]{1,}$", str);
  },
  // 判断是否匹配
  match(patternStr, matchStr) {
    let reg = new RegExp(patternStr);
    return reg.test(matchStr);

  },
  // 保留二位小数，不四舍五入(支持负数)
  keep(val) {
    let str
    let arr
    if (val < 0) {
      let str = val.toString()
      arr = str.split('-')
      str = Number(arr[1].toString().match(/^\d+(?:\.\d{0,2})?/));
      str = "-" + str
      console.log(str);
      return Number(str)
    } else {
      str = Number(val.toString().match(/^\d+(?:\.\d{0,2})?/));
      console.log(str);
      return str
    }
  },
  // 保留一位小数，不四舍五入(支持负数)
  decimal(val) {
    let str
    let arr
    if (val < 0) {
      let str = val.toString()
      arr = str.split('-')
      str = Number(arr[1].toString().match(/^\d+(?:\.\d{0,1})?/));
      str = "-" + str
      console.log(str);
      return Number(str)
    } else {
      str = Number(val.toString().match(/^\d+(?:\.\d{0,1})?/));
      // console.log(str);
      return str
    }
  },

  // 保留n位小数，会自动补 0
  /*
  * val: 值
  * num：位数
  * isNegative： 是否支持负数
  */
  toDecimal(val, isNegative = false){
    let str = "";
    let arr = [];
    if (val < 0 && isNegative) {
      let str = val.toString()
      arr = str.split('-')
      str = arr[1].toString().match(/^\d+(?:\.\d{0,2})?/);
      str = this.keepDecimal(str, 2);
      str = "-" + str
      return str
    } else {
      str = val.toString().match(/^\d+(?:\.\d{0,2})?/);
      if (str !== null) {
        return this.keepDecimal(str, 2);
      }
    }
  },
  // 保留小数（直接剪切），自动补零
  keepDecimal (x, y) {
    var f = parseFloat(x);
    if (isNaN(f)) {
      return false;
    }
    // var f = Math.round(x * 10 * y) / (10 * y);  // 四舍五入
    var s = f.toString();
    if (s.startsWith("-")) {
      s = s.split("-")[1];
    }
    var rs = s.indexOf(".");
    if (rs < 0) {
      rs = s.length;
      s += ".";
    }
    while (s.length <= rs + y) {
      s += "0";
    }
    return s;
  },

  // 是否是将来日期(默认是包含今天)
  _isFutureDate( date, day = 1 ) {
    if (!date) {
      return false;
    }
    let d = new Date(date.replace(/-/g, "/")).getTime();
    let today = new Date().getTime();
    return d > today - (day * 24 * 60 * 60 * 1000);
  },
  

  // 状态码匹配状态
  matchStatus(val){
    let object = {
        "000": "Remove",
        "001": "Draft",
        "002": "Waiting for Data Input",
        "003": "Cancelled",
        "004": "Returned",
        "005": "Submitted",
        "006": "Validated",
        "007": "Seek for Approval",
        "008": "Waiting for Approval",
        "009": "Approved",
        "010": "Ready to Publish",
        "200": "Published",
        "300": "Pending",
        "360": "Completed",
        "040": "Rejected",
        "400": "System Rejected",
    };
    let returnVal = val
    for (const key in object) {
      if (key == val) {
        returnVal = object[key];
      }
    }
    return returnVal;
  },
  /******************************************************* */
  //获取d1签名
  d1GenerateGetSign(params, url) {
    let paramStr = secret + this.d1GenerateParamStr(params, url) + secret;
    if (url.indexOf(baseSSO.refresh_token_url) === -1
      && url.indexOf(baseSSOFED.refresh_token_url) === -1
      && url.indexOf('/dsis/fs/signature-upload-file') === -1
      && url.indexOf('/ns/notifications/msg-summary') === -1
      && url.indexOf('/dacs/ida-task/query/step-group-task-status') === -1
      && url.indexOf("/acs/function-api-mapping/get-function-permission-by-user") === -1
      && url.indexOf("/v1/refreshToken") === -1
    ) {
      window.localStorage.setItem("recent_user_time", new Date().getTime());
    }
    // console.info(paramStr)
    let sign = CryptoJS.SHA256(paramStr).toString().toUpperCase();
    return sign;
  },
  //d1的Param处理
  d1GenerateParamStr(params, url) {
    let unitArray = [];
    let distinctParam = {};
    if (url.indexOf("?") !== -1) {
      let urlParams = url.split("?")[1].split("&");
      if (urlParams.length > 0) {
        for (var i = 0; i < urlParams.length; i++) {
          //排除参数值为空的字段
          if (this.isNotNullNorEmpty(urlParams[i])) {
            let paramsUnitArr = urlParams[i].split("=");
            // console.info(paramsUnitArr)
            //不包含=直接丢掉
            if (paramsUnitArr.length === 2 && this.isNotNullNorEmpty(paramsUnitArr[1])) {
              unitArray.push(paramsUnitArr[0] + "=" + paramsUnitArr[1]);
            }
          }
        }
      }
    }
    let paramArr = Object.keys(params);
    for (let i = 0; i < paramArr.length; i++) {
      let value = params[paramArr[i]];
      if (this.isNotNullNorEmpty(value)) {
        if (typeof value === 'object') {
          for (let j = 0; j < value.length; j++) {
            unitArray.push(paramArr[i] + "=" + encodeURIComponent(value[j]));
          }
        }else{
          if(paramArr[i] === 'body'){
            unitArray.push(paramArr[i] + "=" + value);
          }else{
            unitArray.push(paramArr[i] + "=" + encodeURIComponent(value));
          }
        }
      } else {
        //空值不能丢掉
        unitArray.push(paramArr[i] + "=");
      }
    }
    unitArray.sort();
    let md5Str = unitArray.join("&");
    return md5Str;
  },
  //d1的url处理
  d1EncodeSplitParams(url, params) {
    if (!params) {
      return url;
    }
    let unitArray = [];
    url += url.indexOf("?") === -1 ? '?' : '&';
    let urlParams = url.split("?")[1].split("&");

    let paramArr = Object.keys(params);
    for (let i = 0; i < paramArr.length; i++) {
      let value = params[paramArr[i]];

      //排除参数值为空的字段
      if (this.isNotNullNorEmpty(value)) {
        if (typeof value === 'object') {
          for (let j = 0; j < value.length; j++) {
            unitArray.push(paramArr[i] + "=" + encodeURIComponent(value[j]));
          }
        } else {
          unitArray.push(paramArr[i] + "=" + encodeURIComponent(value));
        }
      }
    }
    unitArray.sort();
    for(let i=0;i<unitArray.length;i++){
      if(i==0){
        url = url + unitArray[i]
      }else {
        url = url + '&' + unitArray[i]
      }
    }
    return url
  },
  // 单元格样式
  cellClassName(val){
    let object = {
      "000": "cell_gray",
      "001": "cell_light_yellow",
      "002": "cell_white",
      "003": "cell_gray", 
      "004": "cell_red",
      "005": "cell_light_green",
      "006": "cell_dark_green",
      "007": "cell_light_blue",
      "009": "cell_approval",
      "010": "cell_ready-to-publish",
      "040": "cell_reject",
      "200": "cell_blue",
      "300": "cell_pending",
      "360": "cell_blue",
      "400": "system-reject",
      "056": "cell_gray",
      "057": "cell_light_green",
      "055": "cell_reject",
      "058": "cell_pending",
      "059": "cell_approval",
      "060": "cell_gray",
      "011": "cell_reject",
      "012": "cell_light_green",
    };
    let returnVal = val
    for (const key in object) {
      if (key === val) {
        returnVal = object[key];
      }
    }
    return returnVal;
  },

  // 获取 Launch Area 勾选的子节点
  get_full_path(data){
    let list = data.filter(item => item.id !== "All");
    var arr = Array();
    list.forEach((item) => {
      // 只需要存入子节点
      if (!item.children || !item.children.length) {
        arr.push(item.id);  
      }
    });

    return arr.length ? arr : null;
  },
  getLaunchAreaLabelMap(launchAreaTree = []) {
    const labelMap = new Map();
    const traverse = (nodes = []) => {
      nodes.forEach(node => {
        labelMap.set(String(node.id), node.label);
        if (node.children && node.children.length) {
          traverse(node.children);
        }
      });
    };

    if (Array.isArray(launchAreaTree)) {
      traverse(launchAreaTree);
    }
    return labelMap;
  },
  collectLaunchAreaDisplayIds(node, checkedKeySet) {
    const children = Array.isArray(node.children) ? node.children : [];
    const nodeId = String(node.id);

    if (!children.length) {
      const isChecked = checkedKeySet.has(nodeId);
      return {
        fullyChecked: isChecked,
        ids: isChecked ? [node.id] : []
      };
    }

    const childResults = children.map(child => this.collectLaunchAreaDisplayIds(child, checkedKeySet));
    const allChildrenChecked = childResults.length > 0 && childResults.every(result => result.fullyChecked);

    if (allChildrenChecked) {
      return {
        fullyChecked: true,
        ids: [node.id]
      };
    }

    return {
      fullyChecked: false,
      ids: childResults.reduce((ids, result) => ids.concat(result.ids), [])
    };
  },
  getOutputLaunchDisplayIds(checkedKeys = [], launchAreaTree = []) {
    if (!Array.isArray(checkedKeys) || !checkedKeys.length) {
      return [];
    }

    if (!Array.isArray(launchAreaTree) || !launchAreaTree.length) {
      return checkedKeys;
    }

    const checkedKeySet = new Set(checkedKeys.map(key => String(key)));
    return launchAreaTree.reduce((ids, node) => {
      const result = this.collectLaunchAreaDisplayIds(node, checkedKeySet);
      return ids.concat(result.ids);
    }, []);
  },
  // 获取 树结构 勾选的label(仅展示父级)
  getTreeLabel(data){
    let list = data.filter(item => item !== "All");
    var d = list.sort();
    var d2 = Array();
    var last = null;
    for (var i = 0; i < d.length; i++) {
      if (last == null) {
        last = d[i];
        d2.push(last);
      } else {
        var cur = d[i];
        if (!cur.startsWith(last)) {
          last = cur;
          d2.push(last);
        }
      }
    }
    return d2;
  },
  // 权限等同于 admin 的角色列表
  bpmRoleAuthority(arr = []){
    let role = JSON.parse(localStorage.userInfo).role;
    let bpmAdmin = ["Product/Price Admin","admin","System Admin","IT Operation","GP Business Admin", "Administrator"];
    if (arr) {
      bpmAdmin = [...arr,...bpmAdmin];
    }
    return bpmAdmin.includes(role);
  },
  // HKTW 权限等同于 admin 的角色列表
  hktwAdmin(arr = []){
    let role = JSON.parse(localStorage.userInfo).role;
    let admin = ["HKTW Product/Price Admin", "IT Operation", "admin", "Business Admin"];
    if (arr) {
      admin = [...arr,...admin];
    }
    return admin.includes(role);
  },

  // GTM 权限等同于 admin 的角色列表
  gtmAdmin(arr = []){
    let role = JSON.parse(localStorage.userInfo).role;
    let admin = ["Product/Price Admin", "admin", 'GP Business Admin'];
    if (arr) {
      admin = [...arr,...admin];
    }
    return admin.includes(role);
  },
  // product price 匹配 product nature 2 字典表
  mapNatureDic(value) {
    let dic = store.getters.getBPMDictionary;
    let dicKey = value;
    for (let key in dic) {
      if (dic[key] === value) {
        dicKey = key;
        break;
      }
    }
    return dicKey;
  },

  /** 
   * @name: 判断是否是 URL 链接
   * @param {*} url 需要校验的字符串
   * @return {*} true || false
  */
  isValidURL(url) {
    try {
      let obj = new URL(url);
      if (["http:", "https:"].includes(obj.protocol) && obj.host !== "") {
        return true;
      } else {
        return false;
      }
    } catch (error) {
      return false;
    }
  },

  // 计算月份相隔
  getMonthDifference(startDate, endDate) {
    const startYear = startDate.getFullYear();
    const startMonth = startDate.getMonth();
    const endYear = endDate.getFullYear();
    const endMonth = endDate.getMonth();
    
    // 计算基础的月份差
    let monthDiff = (endYear - startYear) * 12 + (endMonth - startMonth);
    
    const endDay = endDate.getDate();
    let startDay = startDate.getDate();
    
    // 获取结束日期所在月份的最后一天
    const endMonthLastDay = new Date(endYear, endMonth + 1, 0).getDate();
    
    // 调整起始日的天数不超过结束月份的最后一天
    if (startDay > endMonthLastDay) {
        startDay = endMonthLastDay;
    }
    
    // 如果开始日期大于结束日期，月份差加1
    if (endDay > startDay) {
        monthDiff++;
    }
    
    return monthDiff;
  },

  // 计算相隔天数
  getDaysDifference(startDate, endDate) {
    const oneDay = 24 * 60 * 60 * 1000; // 一天的毫秒数
    return Math.round(Math.abs((startDate - endDate) / oneDay));
  },

  // 判断两个日期是否跨财年 不等于就是跨财年了
  isCrossYear(date1, date2) {
    let startYear = date1.getTime() >= new Date(date1.getFullYear() + '-07-01').getTime() ? date1.getFullYear() + 1 : date1.getFullYear();
    let endYear = date2.getTime() >= new Date(date2.getFullYear() + '-07-01').getTime() ? date2.getFullYear() + 1 : date2.getFullYear();
    return startYear != endYear;
  },
}

// 根据地址获取经纬度  address: 详细地址必填   city: 城市选填
export const getLngLat = (address, city = null) => {
  return new Promise ((reslove, reject) => {
    http.post(`${baseStore}/poh/clinic/getLatitudeAndLongitude`,{},{address, city})
    .then((res) => {
      reslove(res);
  })
    .catch((err) => {
      reslove(err);
   });
  })  
}
// 高德经纬度  转换成  百度经纬度
export const bd_encrypt =($gg_lon,$gg_lat) =>{
  let $x_pi = null;
  let $x = null;
  let $y = null;
  let $z = null;
  let $theta = null;
  let $data = {};
  $x_pi = 3.14159265358979324 * 3000.0 / 180.0;
  $x = $gg_lon;
  $y = $gg_lat;
  $z = Math.sqrt($x * $x + $y * $y) - 0.00002 * Math.sin($y * $x_pi);
  $theta = Math.atan2($y, $x) - 0.000003 * Math.cos($x * $x_pi);
  $data['bd_lon'] = $z * Math.cos($theta) + 0.0065;
  $data['bd_lat'] = $z * Math.sin($theta) + 0.006;
  return $data;
}
// 根据地址获取百度经纬度
export const getBdLngLat = (address, city, that) =>{
  return new Promise ((reslove, reject) => {
    that.$jsonp("http://api.map.baidu.com/geocoding/v3/", {
    address,
    city,
    output: "json",
    ak: "ENlcdiolBqMtZGRvQiED9nk3eZHghBxp",  // 百度地图密钥
  })
    .then((res) => {
    // location 经纬度
    console.log("百度经纬度:",res.result.location);
    reslove(res);
  })
    .catch((err) => {
      reslove(err);
   });
  })  
}

 //判断2个数组是否相等, 忽略顺序
export const arrayIsEqual = (arr1, arr2) => {
  if (!arr1) {
    arr1 = [];
  }
  if (!arr2) {
    arr12 = [];
  }
  if (arr1 === arr2) {
    //如果2个数组对应的指针相同，那么肯定相等，同时也对比一下类型
    return true;
  } else {
    if (arr1.length != arr2.length) {
      return false;
    } else {
      //长度相同
      for (let i in arr1) {
        // arr2 中只要一项不包括arr1 的就不等
        if (!arr2.includes(arr1[i])) {
          return false;
        }
      } 
      //for循环完成，没有出现不相等的情况，那么2个数组相等
      return true;
    }
  }
}

/** 
 * 时间戳转化为年 月 日 时 分 秒 
 * number: 传入时间戳, 默认值当前时间
 * format：返回格式，支持自定义，但参数必须与formateArr里保持一致
*/
export const formatTime = (format, number = new Date().getTime()) => {
  var formateArr = ['Y', 'M', 'D', 'h', 'm', 's'];
  var returnArr = [];
  var date = new Date(number);
  returnArr.push(date.getFullYear());
  returnArr.push(formatNumber(date.getMonth() + 1));
  returnArr.push(formatNumber(date.getDate()));
  returnArr.push(formatNumber(date.getHours()));
  returnArr.push(formatNumber(date.getMinutes()));
  returnArr.push(formatNumber(date.getSeconds()));
  for (var i in returnArr) {
    format = format.replace(formateArr[i], returnArr[i]);
  }
  return format;
}
//数据转化  
function formatNumber(n) {
  n = n.toString();
  return n[1] ? n : '0' + n;
}

/**
 * @name: 给数字加千位符
 * @param {*} num  可为空的数值
 * @return {*} 为空时返回空 传入数值时返回千位符的字符串
 */
export const numThousand = (num) =>{
  if (!num && num != 0) {
    return null;
  }
  num = num.toString().split(".");  // 分隔小数点
  var arr = num[0].split("").reverse();  // 转换成字符数组并且倒序排列
  var res = [];
  for(var i=0,len=arr.length;i<len;i++){
    if(i%3 === 0 && i !== 0){
       res.push(",");   // 添加分隔符
    }
    res.push(arr[i]);
  }
  res.reverse(); // 再次倒序成为正确的顺序
  if(num[1]) {  // 如果有小数的话添加小数部分
    res = res.join("").concat("."+ num[1]);
  } else {
    res = res.join("");
  }
  return res;
}

export const isArray = (val) => {
  return Object.prototype.toString.call(val) === "[object Array]";
};

/**
 * 从菜单中过滤低代码菜单
 * @param {Array} tree 树形结构数据
 * @returns {Array} 符合条件的平铺数组
 */
export function filterLowCodeMenu(menu) {
  if (!Array.isArray(menu)) return [];

  return menu.reduce((result, node) => {
    // 检查条件：projectName 匹配，且 url 不为 null
    const isMatch =
        node.sourceDomain === 'mdm-dataselfserveappcontrol' &&
        node.url; // 新增条件

    // 如果匹配，加入结果（移除 children 避免冗余）
    if (isMatch) {
      const { children, ...rest } = node;
      result.push(rest);
    }

    // 递归处理子节点
    if (node.children) {
      result.push(...filterLowCodeMenu(node.children));
    }

    return result;
  }, []);
}



// WEBPACK FOOTER //
// ./src/util/util.js